// Data
import {
  CompanyEmailAddress,
} from '../../utils/Constants';
// Images
import { MdOutlineEmail } from 'react-icons/md';

export const MainServicesArray = [
  {
    
  }
]

export const contactPinsArray = [
  {
    name: 'Email',
    icon: <MdOutlineEmail className='text-6xl' />,
    url: `mailto:${CompanyEmailAddress}`,
    background: { background: '#FFFC00' },
  },
];